// ─── Clients directory route ───
// /app/clients — issue #207 "Vista todos los proyectos": a company-scoped,
// filterable, read-only grid of every client (name + JP/RT/Sistemas roster)
// in the viewer's active company. Visible to EVERY authenticated user
// (unconditional — unlike the manager-gated Knowledge item); no route-level
// auth guard is needed here, AppLayout already gates authentication.
//
// GHE #1200 / ADR 0039 D9 — this page lived at /app/projects until the
// Proyectos module needed that URL. The old path redirects here.

import { createFileRoute } from '@tanstack/react-router';
import { ClientDirectoryPage } from '../../features/clients/ClientDirectoryPage';

export const Route = createFileRoute('/app/clients')({
  component: ClientDirectoryPage,
});
